import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react/enhancers';
import { compose } from '@beef/utils';
import classNames from 'classnames/bind';
import { AccumulatorsInfoTag } from '@beef/elk-common';
import { selectAccumMainCtn } from "../store";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
var _InfoTag = function _InfoTag(_ref) {
  var mainCtn = _ref.mainCtn;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('wrapper'),
    "data-t-id": "Mobile-InfoTag"
  }, /*#__PURE__*/React.createElement(AccumulatorsInfoTag, {
    mainCtn: mainCtn !== null && mainCtn !== void 0 ? mainCtn : ''
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  var mainCtn = selectAccumMainCtn(state);
  return {
    mainCtn: mainCtn,
    shouldRender: !!mainCtn
  };
};
var connector = connect(mapStateToProps);
export var InfoTag = compose(connector, withRenderFlag)(_InfoTag);